import { AxiosPromise } from 'axios';
import {
    ClientField,
    CreateClientFieldRequest,
    UpdateClientFieldRequest,
} from '../../types/ClientField';
import { libApiInstance } from '../axios';

export function requestClientFields(signal?: AbortSignal): AxiosPromise<ClientField[]> {
    return libApiInstance.get(`/clients/fields`, { signal });
}

export function requestCreateClientField(
    data: CreateClientFieldRequest,
    signal?: AbortSignal,
): AxiosPromise<ClientField> {
    return libApiInstance.post('/clients/fields', data, { signal });
}

export function requestUpdateClientField(
    data: UpdateClientFieldRequest,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.put(`/clients/fields`, data, { signal });
}

export function requestDeleteClientField(
    fieldId: number,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.delete(`/clients/fields/${fieldId}`);
}
